import React, { useRef } from 'react'
import { InputNumber } from 'primereact/inputnumber'

export default function LtsInputNumber(props) {
  const { label, value, onChange, id, inputId, onBlur, inputProps: inputPropsProp, ...restProps } = props

  const parseNumericValue = (raw) => {
    if (raw == null) return null
    if (typeof raw === 'number' && !Number.isNaN(raw)) return raw
    const str = String(raw).trim()
    if (!str) return null

    const normalized = str
      .replace(/\s/g, '')
      .replace(/\./g, '')
      .replace(/,/g, '.')
      .replace(/[^0-9.-]/g, '')

    if (!normalized) return null
    const n = Number(normalized)
    return Number.isNaN(n) ? null : n
  }

  const fallbackIdRef = useRef(null)
  if (!fallbackIdRef.current) {
    fallbackIdRef.current = `lts-input-number-${Math.random().toString(36).slice(2, 10)}`
  }

  const resolvedId = inputId ?? id ?? fallbackIdRef.current
  const resolvedValue = value == null ? null : value

  return (
    <span className="p-float-label">
      <InputNumber
        {...restProps}
        inputId={resolvedId}
        value={resolvedValue}
        allowEmpty={restProps.allowEmpty ?? true}
        onValueChange={(e) => onChange?.(e.value)}
        onChange={(e) => onChange?.(e.value)}
        onBlur={(e) => {
          const parsed = parseNumericValue(e?.target?.value)
          const current = typeof value === 'number' && !Number.isNaN(value) ? value : null
          if (parsed !== current) onChange?.(parsed)
          onBlur?.(e)
        }}
        inputProps={{
          ...(inputPropsProp || {}),
          autoComplete: (inputPropsProp && inputPropsProp.autoComplete) || 'off',
        }}
      />
      {label ? <label htmlFor={resolvedId}>{label}</label> : null}
    </span>
  )
}
